import router from "../router";
import store from "../store";


export default function toLogin(push, backUrl) {

  const { fullPath, name } = router.currentRoute;

    if (name !== "Login") {
       router.push({ path: "/login" });
    }

}



// WEBPACK FOOTER //
// ./src/api/login.js